import React, { useState, useEffect } from 'react';
import './UpdateBanner.css';

function UpdateBanner() {
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    const handleUpdate = event => {
      const registration = event.detail;
      if (registration && registration.waiting) {
        setWaitingWorker(registration.waiting);
      }
    };
    window.addEventListener('swUpdate', handleUpdate);
    return () => window.removeEventListener('swUpdate', handleUpdate);
  }, []);

  const handleRefresh = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  };

  if (!waitingWorker) return null;

  return (
    <div className="update-banner">
      <span className="update-banner-text">Nouvelle version disponible</span>
      <button className="update-banner-btn" onClick={handleRefresh}>
        Actualiser
      </button>
    </div>
  );
}

export default UpdateBanner;
